import Icon from '../../components/common/Icon';
import React, { useEffect, useState, useCallback } from 'react';
import { useT } from '../../context/TenantContext';
import { useNavigate } from 'react-router-dom';
import BackDeskLayout from '../../components/layout/BackDeskLayout';
import { useRealtime } from '../../hooks/useRealtime';
import { Button } from '../../components/ui';

const token = () => localStorage.getItem('hd_token');
const h = () => ({ Authorization: `Bearer ${token()}` });

function fmt(dt) {
  if (!dt) return '—';
  const d = new Date(dt);
  const diff = (Date.now() - d) / 1000;
  if (diff < 60)   return 'hace un momento';
  if (diff < 3600) return `hace ${Math.floor(diff/60)}m`;
  if (diff < 86400) return `hace ${Math.floor(diff/3600)}h`;
  return d.toLocaleDateString('es-ES', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' });
}

export default function Computers() {
  const { t } = useT();
  const navigate   = useNavigate();
  const [computers, setComputers] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [search,    setSearch]    = useState('');

  const load = useCallback(() => {
    fetch('/api/computers', { headers: h() })
      .then(r => r.json())
      .then(data => { setComputers(Array.isArray(data) ? data : []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  // Actualizar en tiempo real cuando un agente conecta/desconecta
  useRealtime(useCallback((event) => {
    if (event.type === 'computer_online' || event.type === 'computer_offline') {
      load();
    }
  }, [load]));

  const filtered = computers.filter(c =>
    !search ||
    c.hostname?.toLowerCase().includes(search.toLowerCase()) ||
    c.username?.toLowerCase().includes(search.toLowerCase()) ||
    c.local_ip?.includes(search)
  );

  const onlineCount = computers.filter(c => c.online).length;

  return (
    <BackDeskLayout title={t('nav.computers')}
      actions={
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <span style={{fontSize:12,fontWeight:600,padding:'4px 12px',borderRadius:20,
            background:'#F0FDF4',color:'#15803D',border:'1px solid #86EFAC'}}>
            ● {onlineCount} online
          </span>
          <span style={{fontSize:12,color:'#9CA3AF'}}>{computers.length} equipos registrados</span>
        </div>
      }>

      {/* Buscador */}
      <div style={{marginBottom:16}}>
        <input
          placeholder="Buscar por nombre, usuario o IP..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{
            width:'100%', height:40, padding:'0 16px',
            border:'1.5px solid #E5E7EB', borderRadius:10,
            fontSize:13, outline:'none', color:'#111827',
            fontFamily:'var(--font-body)',
          }}
        />
      </div>

      {loading
        ? <div className="bd-loading"><div className="bd-spinner-sm"/>Cargando...</div>
        : filtered.length === 0
          ? <div style={{padding:40,textAlign:'center',color:'#9CA3AF',fontSize:13}}>
              <Icon name="computer" size={32} style={{color:"#9CA3AF",marginBottom:8}} />
              {computers.length === 0
                ? 'Ningún equipo conectado todavía. Instala el agente en los equipos.'
                : 'Sin resultados para esa búsqueda.'}
            </div>
          : (
            <div style={{background:'#fff',border:'1px solid #E5E7EB',borderRadius:12,overflow:'hidden',boxShadow:'0 1px 3px rgba(0,0,0,.05)'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr style={{background:'#FAFAFA'}}>
                    {['Estado','Equipo','Usuario','IP','OS','Versión agente','Última vez','Acciones'].map(h=>(
                      <th key={h} style={{padding:'10px 16px',textAlign:'left',fontSize:10,fontWeight:600,
                        letterSpacing:.4,textTransform:'uppercase',color:'#9CA3AF',
                        borderBottom:'1px solid #F3F4F6'}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(c => (
                    <tr key={c.id}
                      style={{borderBottom:'1px solid #F9FAFB',cursor:'pointer'}}
                      onMouseOver={e => e.currentTarget.style.background='#F9FAFB'}
                      onMouseOut={e => e.currentTarget.style.background=''}
                      onClick={() => navigate(`/backdesk/computers/${c.id}`)}>

                      <td style={{padding:'12px 16px'}}>
                        <div style={{width:10,height:10,borderRadius:'50%',
                          background: c.online ? '#15803D' : '#D1D5DB'}}/>
                      </td>
                      <td style={{padding:'12px 16px'}}>
                        <div style={{fontSize:13,fontWeight:600,color:'#111827'}}>{c.hostname}</div>
                        <div style={{fontSize:11,color:'#9CA3AF'}}>{c.site_name}</div>
                      </td>
                      <td style={{padding:'12px 16px',fontSize:12,color:'#374151'}}>{c.username || '—'}</td>
                      <td style={{padding:'12px 16px',fontSize:12,fontFamily:'monospace',color:'#0085CA'}}>{c.local_ip || '—'}</td>
                      <td style={{padding:'12px 16px',fontSize:12,color:'#374151',maxWidth:180,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.os || '—'}</td>
                      <td style={{padding:'12px 16px'}}>
                        <span style={{fontSize:11,fontFamily:'monospace',padding:'2px 7px',
                          borderRadius:6,background:'#F3F4F6',color:'#6B7280'}}>
                          v{c.agent_version || '?'}
                        </span>
                      </td>
                      <td style={{padding:'12px 16px',fontSize:12,color:'#9CA3AF'}}>{fmt(c.last_seen)}</td>
                      <td style={{padding:'12px 16px'}}>
                        <Button
                          variant="primary"
                          style={{height:30,fontSize:11}}
                          onClick={e => { e.stopPropagation(); navigate(`/backdesk/computers/${c.id}`); }}>
                          Ver detalle
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
      }

      {/* Instrucciones instalación */}
      {computers.length === 0 && !loading && (
        <div style={{marginTop:20,padding:'16px 20px',background:'#F0FDF4',border:'1px solid #86EFAC',
          borderRadius:12,fontSize:12,color:'#15803D',lineHeight:1.8}}>
          <strong style={{display:'block',marginBottom:4}}>🚀 Cómo instalar el agente</strong>
          <code style={{display:'block',background:'rgba(0,0,0,.05)',padding:'4px 8px',borderRadius:4,marginBottom:4}}>
            helpdesk-agent.exe -server http://192.168.X.X:3000 -install
          </code>
          Los equipos aparecerán aquí automáticamente en menos de 60 segundos.
        </div>
      )}
    </BackDeskLayout>
  );
}
